var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "unified-navigation-ui": "static-1.24795",
      "ably-hubspot-js": "static-1.435",
      "enviro": "static-4.275",
      "head-dlb": "static-1.2601",
      "hs-lodash": "static-4.9",
      "hs-promise-utils": "static-1.3006",
      "hs-test-utils": "static-1.5585",
      "hub-http": "static-1.2732",
      "hubspot-url-utils": "static-1.2067",
      "HubStyleTokens": "static-2.9134",
      "I18n": "static-7.1304",
      "jasmine-runner": "static-1.3956",
      "nav-meta": "static-1.23588",
      "navigation-components": "static-1.11951",
      "navigation-components-tests": "static-1.8561",
      "quartz": "static-1.4147",
      "react": "static-7.133",
      "react-dnd": "static-2.33",
      "react-dnd-html5-backend": "static-2.10",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "webpack-env": "static-1.41",
      "wootric-nps": "static-1.4525",
      "ably": "static-1.18",
      "calling-internal-common": "static-1.28538",
      "classnames": "static-2.10",
      "crosstab": "static-1.2141",
      "ExtensionInstallHelpers": "static-1.507",
      "foundations-components": "static-1.4336",
      "foundations-theming": "static-1.1525",
      "foundations-theming-base": "static-1.510",
      "frontend-preferences-client": "static-1.5412",
      "global-search-externals": "static-1.6823",
      "idb-keyval": "static-1.14",
      "magpie-lib": "static-1.3041",
      "magpie-types": "static-1.2500",
      "metrics-js": "static-1.7188",
      "nav-onboarding-tours": "static-1.595",
      "navigation-messaging": "static-1.1278",
      "notification-sounds": "static-1.1987",
      "prefetcher": "static-1.3312",
      "react-dom": "static-7.85",
      "react-utils": "static-2.3254",
      "redux-thunk": "static-2.17",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.5736",
      "simple-logging-lib": "static-1.648",
      "styled-components": "static-2.40",
      "superstore": "static-1.2303",
      "trial-components-library": "static-1.8979",
      "ts-schema": "static-1.1994",
      "ui-images": "static-2.766",
      "usage-tracker-core": "static-1.4978",
      "hs-promise-rejection-tracking": "static-1.2994",
      "PortalIdParser": "static-2.254",
      "raven": "static-3.3326",
      "raven-hubspot": "static-1.3633",
      "bend-plugin-trellis-migration": "static-1.1174",
      "moment": "static-3.26",
      "HeadJS": "static-2.518",
      "quartz-core": "static-1.3366",
      "framer-motion": "static-1.30",
      "hs-test-utils-bend-plugin": "static-1.696",
      "msw": "static-1.39",
      "testing-library": "static-1.113",
      "i18n-data": "static-1.188",
      "moment-timezone": "static-5.17",
      "jasmine": "static-4.1870",
      "quartz-core-utils": "static-1.1014",
      "StyleGuideUI": "static-3.433",
      "csstype": "static-1.8",
      "hoist-non-react-statics": "static-3.9",
      "HubStyle": "static-2.9444",
      "calling-error-reporting": "static-1.28543",
      "calling-usage-tracker": "static-1.4073",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "quick-fetch": "static-1.1826",
      "self-service-api": "static-1.7644",
      "SharedI18nStrings": "static-1.160",
      "UIComponents": "static-3.6084",
      "bend-plugin-foundations-components": "static-1.604",
      "floating-ui": "static-1.20",
      "foundations-assets": "static-1.2360",
      "hs-story-utils": "static-1.6592",
      "react-aria": "static-1.32",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.67",
      "tanstack-table": "static-1.10",
      "ui-fonts": "static-1.327",
      "global-search-shared": "static-1.7535",
      "usage-tracker": "static-1.5128",
      "react-rhumb": "static-1.14103",
      "autolinker": "static-3.11",
      "sanitize": "static-1.6",
      "transmute": "static-2.29",
      "atom": "static-1.2939",
      "ai-components-ui-library": "static-1.3598",
      "copilot-toolkit": "static-1.2824",
      "demographics-client": "static-1.2914",
      "icons": "static-2.585",
      "laboratory-lib": "static-3.4687",
      "react-input-autosize": "static-2.17",
      "salesImages": "static-1.490",
      "signup-constants": "static-1.14143",
      "ui-addon-i18n": "static-1.8336",
      "ui-addon-upgrades": "static-9.14393",
      "user-context": "static-1.2627",
      "dispatcher": "static-1.105",
      "general-store": "static-6.20",
      "history": "static-4.15",
      "hub-http-janus": "static-1.586",
      "hub-http-shared-msw-handlers": "static-1.5479",
      "hubspotter-http": "static-1.2601",
      "hubspotter-http-shared-msw-handlers": "static-1.5477",
      "mobile-manifest-mixins": "static-1.289",
      "platform-navigation-bootstrap": "static-1.9412",
      "react-router-dom": "static-5.26",
      "cssUtils": "static-1.321",
      "customer-data-ui-utilities": "static-1.7315",
      "ai-addon-copilot-preview": "static-1.2810",
      "apollo-link-hub-http": "static-2.2302",
      "apollo-stack-hubspot": "static-3.43",
      "data-fetching-client": "static-1.6851",
      "graphql": "static-1.51",
      "search-service-types": "static-1.1666",
      "chatspot-client-types": "static-1.6777",
      "chatspot-core": "static-1.11911",
      "ContentUtils": "static-1.59744",
      "sassPrefix": "static-1.122",
      "feature-store-service-types": "static-1.2470",
      "growth-monetization-service-types": "static-1.2477",
      "rpc-client-utils": "static-1.2218",
      "upgrade-management-service-types": "static-1.2461",
      "getting-started-shared-tasks": "static-1.7820",
      "getting-started-shared-tasks-store": "static-1.6938",
      "platform-infra-nav-components": "static-1.5703",
      "react-dnd-compat": "static-1.2024",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "ai-settings-ui-library": "static-1.4175",
      "cms-field-types": "static-1.2311",
      "content-icons-ui": "static-1.1816",
      "underscore": "static-1.8",
      "ui-addon-avatars": "static-2.7080",
      "ui-addon-react-router-dom": "static-1.7113",
      "usage-tracker-container": "static-1.5118"
    },
    "depPathPrefixes": {
      "unified-navigation-ui": "/unified-navigation-ui/static-1.24795",
      "ably-hubspot-js": "/ably-hubspot-js/static-1.435",
      "enviro": "/enviro/static-4.275",
      "head-dlb": "/head-dlb/static-1.2601",
      "hs-lodash": "/hs-lodash/static-4.9",
      "hs-promise-utils": "/hs-promise-utils/static-1.3006",
      "hs-test-utils": "/hs-test-utils/static-1.5585",
      "hub-http": "/hub-http/static-1.2732",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.2067",
      "HubStyleTokens": "/HubStyleTokens/static-2.9134",
      "I18n": "/I18n/static-7.1304",
      "jasmine-runner": "/jasmine-runner/static-1.3956",
      "nav-meta": "/nav-meta/static-1.23588",
      "navigation-components": "/navigation-components/static-1.11951",
      "navigation-components-tests": "/navigation-components-tests/static-1.8561",
      "quartz": "/quartz/static-1.4147",
      "react": "/react/static-7.133",
      "react-dnd": "/react-dnd/static-2.33",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "webpack-env": "/webpack-env/static-1.41",
      "wootric-nps": "/wootric-nps/static-1.4525",
      "ably": "/ably/static-1.18",
      "calling-internal-common": "/calling-internal-common/static-1.28538",
      "classnames": "/classnames/static-2.10",
      "crosstab": "/crosstab/static-1.2141",
      "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.507",
      "foundations-components": "/foundations-components/static-1.4336",
      "foundations-theming": "/foundations-theming/static-1.1525",
      "foundations-theming-base": "/foundations-theming-base/static-1.510",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.5412",
      "global-search-externals": "/global-search-externals/static-1.6823",
      "idb-keyval": "/idb-keyval/static-1.14",
      "magpie-lib": "/magpie-lib/static-1.3041",
      "magpie-types": "/magpie-types/static-1.2500",
      "metrics-js": "/metrics-js/static-1.7188",
      "nav-onboarding-tours": "/nav-onboarding-tours/static-1.595",
      "navigation-messaging": "/navigation-messaging/static-1.1278",
      "notification-sounds": "/notification-sounds/static-1.1987",
      "prefetcher": "/prefetcher/static-1.3312",
      "react-dom": "/react-dom/static-7.85",
      "react-utils": "/react-utils/static-2.3254",
      "redux-thunk": "/redux-thunk/static-2.17",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.5736",
      "simple-logging-lib": "/simple-logging-lib/static-1.648",
      "styled-components": "/styled-components/static-2.40",
      "superstore": "/superstore/static-1.2303",
      "trial-components-library": "/trial-components-library/static-1.8979",
      "ts-schema": "/ts-schema/static-1.1994",
      "ui-images": "/ui-images/static-2.766",
      "usage-tracker-core": "/usage-tracker-core/static-1.4978",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.2994",
      "PortalIdParser": "/PortalIdParser/static-2.254",
      "raven": "/raven/static-3.3326",
      "raven-hubspot": "/raven-hubspot/static-1.3633",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.1174",
      "moment": "/moment/static-3.26",
      "HeadJS": "/HeadJS/static-2.518",
      "quartz-core": "/quartz-core/static-1.3366",
      "framer-motion": "/framer-motion/static-1.30",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.696",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.113",
      "i18n-data": "/i18n-data/static-1.188",
      "moment-timezone": "/moment-timezone/static-5.17",
      "jasmine": "/jasmine/static-4.1870",
      "quartz-core-utils": "/quartz-core-utils/static-1.1014",
      "StyleGuideUI": "/StyleGuideUI/static-3.433",
      "csstype": "/csstype/static-1.8",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "HubStyle": "/HubStyle/static-2.9444",
      "calling-error-reporting": "/calling-error-reporting/static-1.28543",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.4073",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "quick-fetch": "/quick-fetch/static-1.1826",
      "self-service-api": "/self-service-api/static-1.7644",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.160",
      "UIComponents": "/UIComponents/static-3.6084",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.604",
      "floating-ui": "/floating-ui/static-1.20",
      "foundations-assets": "/foundations-assets/static-1.2360",
      "hs-story-utils": "/hs-story-utils/static-1.6592",
      "react-aria": "/react-aria/static-1.32",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.67",
      "tanstack-table": "/tanstack-table/static-1.10",
      "ui-fonts": "/ui-fonts/static-1.327",
      "global-search-shared": "/global-search-shared/static-1.7535",
      "usage-tracker": "/usage-tracker/static-1.5128",
      "react-rhumb": "/react-rhumb/static-1.14103",
      "autolinker": "/autolinker/static-3.11",
      "sanitize": "/sanitize/static-1.6",
      "transmute": "/transmute/static-2.29",
      "atom": "/atom/static-1.2939",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.3598",
      "copilot-toolkit": "/copilot-toolkit/static-1.2824",
      "demographics-client": "/demographics-client/static-1.2914",
      "icons": "/icons/static-2.585",
      "laboratory-lib": "/laboratory-lib/static-3.4687",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "salesImages": "/salesImages/static-1.490",
      "signup-constants": "/signup-constants/static-1.14143",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.8336",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.14393",
      "user-context": "/user-context/static-1.2627",
      "dispatcher": "/dispatcher/static-1.105",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.15",
      "hub-http-janus": "/hub-http-janus/static-1.586",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.5479",
      "hubspotter-http": "/hubspotter-http/static-1.2601",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.5477",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.289",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.9412",
      "react-router-dom": "/react-router-dom/static-5.26",
      "cssUtils": "/cssUtils/static-1.321",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.7315",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.2810",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.2302",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "data-fetching-client": "/data-fetching-client/static-1.6851",
      "graphql": "/graphql/static-1.51",
      "search-service-types": "/search-service-types/static-1.1666",
      "chatspot-client-types": "/chatspot-client-types/static-1.6777",
      "chatspot-core": "/chatspot-core/static-1.11911",
      "ContentUtils": "/ContentUtils/static-1.59744",
      "sassPrefix": "/sassPrefix/static-1.122",
      "feature-store-service-types": "/feature-store-service-types/static-1.2470",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.2477",
      "rpc-client-utils": "/rpc-client-utils/static-1.2218",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.2461",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.7820",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.6938",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.5703",
      "react-dnd-compat": "/react-dnd-compat/static-1.2024",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.4175",
      "cms-field-types": "/cms-field-types/static-1.2311",
      "content-icons-ui": "/content-icons-ui/static-1.1816",
      "underscore": "/underscore/static-1.8",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.7080",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.7113",
      "usage-tracker-container": "/usage-tracker-container/static-1.5118"
    },
    "project": "unified-navigation-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};